import { render } from "./SWN_V.vue?vue&type=template&id=41d3a5c0&scoped=true"
import script from "./SWN_V.vue?vue&type=script&lang=js"
export * from "./SWN_V.vue?vue&type=script&lang=js"

import "./SWN_V.vue?vue&type=style&index=0&id=41d3a5c0&scoped=true&lang=stylus"

import exportComponent from "C:\\Users\\Administrator\\betaver_webpage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d3a5c0"]])

export default __exports__